/*global Modernizr, console */
/*jslint browser:true */

(function() {
  'use strict';

  var tables = document.querySelectorAll('table');
  if(tables) {
    tables.forEach((table) => {
      if(!table.classList.contains('tribe-events-calendar-month') && !table.classList.contains('compact') && !table.parentNode.classList.contains('table-container')) {
        var table_wrapper = document.createElement('div');
        table_wrapper.classList.add('table-container');

        table_wrapper.innerHTML = `<div class="scroll-indicator">
        <span class="icon arrow-left"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 15.334"><path d="M.705 0L0 .705l6.961 6.962L0 14.629l.705.705 7.667-7.667z"></path><path d="M8.019 0l-.705.705 6.961 6.962-6.961 6.962.705.705 7.666-7.667z"></path><path d="M15.334 0l-.706.705 6.962 6.962-6.962 6.962.706.705L23 7.667z"></path></svg></span>
        <span>Scroll to see more</span>

        <span class="icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 15.334"><path d="M.705 0L0 .705l6.961 6.962L0 14.629l.705.705 7.667-7.667z"></path><path d="M8.019 0l-.705.705 6.961 6.962-6.961 6.962.705.705 7.666-7.667z"></path><path d="M15.334 0l-.706.705 6.962 6.962-6.962 6.962.706.705L23 7.667z"></path></svg></span>      </div>`;

        table.parentNode.insertBefore(table_wrapper, table);
        table_wrapper.appendChild(table);
      }
    });
  }

  var table_containers = document.querySelectorAll('.table-container');
  if(table_containers) {
    table_containers.forEach((table_container) => {
      check_table_overflow(table_container);

      window.addEventListener('resize', () => {
        check_table_overflow(table_container);
      });
    });
  }

  function check_table_overflow(table_container) {
    if(table_container.scrollWidth > table_container.offsetWidth) {
      table_container.classList.add('overflow');
    } else {
      table_container.classList.remove('overflow');
    }
  }
}());